const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "things go here", // <title>
  shortSiteTitle: "subtitle goes here", // <title> ending for posts and pages
  siteDescription: "description goes here",
  siteUrl: "https://thingsgohere.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "michael oostdyk",
  authorTwitterAccount: "saymikeo",
  // info
  infoTitle: "things go here",
  infoTitleNote: "michael oostdyk",
  // manifest.json
  manifestName: "things go here",
  manifestShortName: "thingsgohere", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.bg,
  manifestThemeColor: colors.bg,
  manifestDisplay: "standalone",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/styks1987" },
    { name: "twitter", url: "https://twitter.com/saymikeo" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js